import React from "react";

const HexagonCard = ({ icon, title, onClick, note }) => {
  return (
    <div className="flex flex-col items-center">
      {note && (
        <div className="text-sm font-medium text-gray-600 mb-1 text-center">
          {note}
        </div>
      )}
      <div
        onClick={onClick}
        style={{
          clipPath:
            "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
        }}
        className="w-48 h-[10.2rem] bg-purple-500 flex items-center justify-center cursor-pointer hover:scale-105 transition-transform"
      >
        {/* Inner Hexagon */}
        <div
          style={{
            clipPath:
              "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
          }}
          className="w-[99%] h-[99%] bg-[#EFF8FF] flex flex-col items-center justify-center shadow-md gap-4"
        >
          <img src={icon} alt={title} className="w-20 h-20" />
          <button
            onClick={onClick}
            style={{
              background: "linear-gradient(90deg, #667EEA, #764BA2)",
            }}
            className="text-white font-semibold text-sm px-1.5 py-1.5 rounded-full shadow-md transition hover:opacity-90"
          >
            {title}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HexagonCard;

 